export function isImageBitmap(image) {
  return typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap;
}
export function isWorker() {
  return typeof importScripts === 'function';
}
export var getReferrer = isWorker() ? function () {
  return self.worker && self.worker.referrer;
} : function () {
  return (window.location.protocol === 'blob:' ? window.parent : window).location.href;
};
//# sourceMappingURL=env.js.map